import i18n from "i18next";
import { Message } from 'rsuite';
import { Request } from 'kaiju.ui2';
import { jsx as _jsx } from "react/jsx-runtime";
const VerifyStore = props => { return { fields: [{ id: "auth", fields: [{ id: "code", kind: "string", required: true, label: i18n.t("user.code"), min: 6, max: 6, reg_exp: /\d+/, reg_exp_text: "", mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/] }] }], disableGroups: true, onSubmit: (values, formikState) => { Request('auth.reg_verf_code', values).then(data => { const error = data.error; if (error) {
        const code = error.data.code;
        const message = i18n.t(code);
        props.toaster.push(/*#__PURE__*/ _jsx(Message, { duration: 3000, showIcon: true, type: 'error', header: i18n.t('auth.user.authentication_error'), children: message }), { placement: "topEnd" });
    }
    else {
        props.navigateCallback();
    } }); } }; };
export default VerifyStore;
